var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "table-wrapper" }, [
      _c("table", { staticClass: "account-credit" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.displayedItems, function(user, index) {
            return _c("tr", { key: index }, [
              _c("td", [
                _c("span", [_vm._v(_vm._s(_vm._f("formatDate")(user.date)))])
              ]),
              _vm._v(" "),
              _c("td", [
                user.credit
                  ? _c("span", [_vm._v("$" + _vm._s(user.credit.toFixed(2)))])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("td", [
                user.adjustment
                  ? _c("span", [
                      _vm._v("$" + _vm._s(user.adjustment.toFixed(2)))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("td", [
                user.orderNumber
                  ? _c("span", [_vm._v(_vm._s(user.orderNumber))])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("td", [
                user.reference
                  ? _c("span", [_vm._v(_vm._s(user.reference))])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("td", [
                user.balance
                  ? _c("span", [_vm._v("$" + _vm._s(user.balance.toFixed(2)))])
                  : _c("span", [_vm._v("$0.00")])
              ])
            ])
          }),
          0
        )
      ])
    ]),
    _vm._v(" "),
    _c("br"),
    _vm._v(" "),
    _c("br"),
    _vm._v(" "),
    _vm.user && _vm.user.length > 0
      ? _c("div", { staticClass: "col-sm-12 col-md-12" }, [
          _c(
            "button",
            {
              staticClass: "pagination-button",
              attrs: { disabled: _vm.currentPage === 1 },
              on: { click: _vm.prevPage }
            },
            [_vm._v("\n      Previous\n    ")]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "current-page" }, [
            _vm._v(
              "Page " +
                _vm._s(_vm.currentPage) +
                " of " +
                _vm._s(_vm.totalPages)
            )
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "pagination-button",
              attrs: { disabled: _vm.currentPage === _vm.totalPages },
              on: { click: _vm.nextPage }
            },
            [_vm._v("\n      Next\n    ")]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Date")]),
        _vm._v(" "),
        _c("th", [_vm._v("Credit")]),
        _vm._v(" "),
        _c("th", [_vm._v("Adjustment")]),
        _vm._v(" "),
        _c("th", [_vm._v("Order Number")]),
        _vm._v(" "),
        _c("th", [_vm._v("Reference")]),
        _vm._v(" "),
        _c("th", [_vm._v("Balance")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }